import React from "react";
import { LegalPageEditor } from "@/components/pages/legal-pages/LegalPageEditor";
import { LegalPageView } from "@/components/pages/legal-pages/LegalPageView";

interface TermsOfUsePageProps {
  mode?: "edit" | "view";
}

export const TermsOfUsePage = ({
  mode = "edit",
}: TermsOfUsePageProps): React.JSX.Element => {
  if (mode === "view") {
    return (
      <LegalPageView
        type="terms-of-use"
        titleKey="layout.superAdminNav.items.settings.terms_of_use"
      />
    );
  }

  return <LegalPageEditor type="terms-of-use" />;
};
